import { TFunction } from 'i18next';

import { TabsType } from './types';

export const getTabs = (
  t: TFunction,
  options: {
    isStock: boolean;
    is404Error: boolean;
    isDocumentsTabVisible: boolean;
  }
) => [
  {
    tabKey: TabsType.Overview,
    tabLabel: t('widget:assetOverview.overview'),
  },
  {
    tabKey: TabsType.Financials,
    tabLabel: t('asset-overview:financials'),
    isHidden: !options.isStock,
  },
  {
    tabKey: TabsType.Chart,
    tabLabel: t('widget:assetOverview.chart'),
  },
  {
    tabKey: TabsType.Connections,
    tabLabel: t('widget:assetOverview.knowledgeGraph.name'),
    isHidden: options.is404Error,
  },
  {
    tabKey: TabsType.NewsInsights,
    tabLabel: t('widget:assetOverview.news'),
    isHidden: !options.isStock,
  },
  {
    tabKey: TabsType.Documents,
    tabLabel: t('widget:assetOverview.documents'),
    isHidden: !options.isDocumentsTabVisible,
  },
  {
    tabKey: TabsType.Earnings,
    tabLabel: t('widget:assetOverview.earnings'),
    isHidden: !options.isStock,
  },
];
